import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { LabelWithIconInfo } from '../../../../common/LabelWithIconInfo'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { BusinessSizeTable } from './BusinessSizeTable'
import { BusinessSizePieChart } from './pieChart'
import { resetStore, selectData, selectIsLoading } from './store/slice'
import { exportBusinessSize, getBusinessSizeTable } from './store/thunk'

export const BusinessSize = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { currency } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const data = useSelector(selectData)
  const isLoading = useSelector(selectIsLoading)
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationShortName, organizationName, taxCode, companyType } =
    useSelector(selectCompanyInfo)
  const label = UseI18n('industryOverview.businessSize.BUSINESS_BY_SIZE')

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    if (currency) {
      dispatch(
        getBusinessSizeTable({
          OrganizationId: params.organizationId,
          Currency: currency,
        }),
      )
    }
  }, [locale, params.organizationId, currency])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="h100 positionRelative">
          <Loading />
        </div>
      )
    }

    if (!Object.keys(data).length) {
      return <Notification />
    }

    return (
      <div className="flexColumn h100">
        <div id="businessSizePieChartId">
          <BusinessSizePieChart />
        </div>

        <div className="flex1">
          <BusinessSizeTable />
        </div>
      </div>
    )
  }

  return (
    <Panel
      id="businessSizeId"
      height={364}
      renderLabel={() => (
        <LabelWithIconInfo
          label={'industryOverview.businessSize.BUSINESS_BY_SIZE'}
          renderToolTipContent={() => (
            <Translate
              value={
                companyType === COMPANY_TYPES.BANK
                  ? 'industryOverview.businessSize.BANK_TOOLTIP'
                  : 'industryOverview.businessSize.TOOLTIP'
              }
            />
          )}
        />
      )}
      type={panelTypes.HALF_SIZE}
      downloadJpgParams={{
        disabled: !Object.keys(data).length,
        arrName: [
          label,
          organizationShortName || organizationName || taxCode || '',
        ],
        domId: 'businessSizePieChartId',
        titleJpg: label,
      }}
      downloadCsv={{
        disabled: !Object.keys(data).length,
        downloadFunc: () =>
          exportBusinessSize({
            OrganizationId: params.organizationId,
            Currency: currency,
          }),
      }}
    >
      {renderContent()}
    </Panel>
  )
}
